import { useFormContext } from 'react-hook-form';
import { v4 as uuidv4 } from 'uuid';
import { ReactComponent as InfoCircle } from 'assets/images/InfoCircle.svg?react';
import RootInput from 'components/Input/RootInput/RootInput';
import { type RootInputProps } from 'components/Input/RootInput/types';
import { TooltipMessage } from 'enums/Messages';
import { type FCC } from 'types';
import { PHONE_MASK_OPTIONS, PHONE_PLACEHOLDER } from './config';

type Props = Pick<RootInputProps, 'name' | 'label' | 'required' | 'containerClassName'>;

const PhoneNumberInput: FCC<Props> = (props) => {
  const { name, label, containerClassName, required } = props;

  const { control, clearErrors, setError } = useFormContext();

  return (
    <RootInput
      key="phone"
      type="tel"
      name={name}
      label={label}
      control={control}
      maskOptions={PHONE_MASK_OPTIONS}
      setError={setError}
      placeholder={PHONE_PLACEHOLDER}
      tooltipText={TooltipMessage.Phone}
      clearErrors={clearErrors}
      icon={<InfoCircle />}
      onChangeResetTooltip
      autoComplete={uuidv4()}
      containerClassName={containerClassName}
      required={required}
    />
  );
};

export default PhoneNumberInput;
